var swiper = new Swiper(".js-research-ingredients-swiper", {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        576: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            loop: true,
        },
        768: {
            slidesPerView: 4,
            slidesPerGroup: 2,
            loop: true,
        },
        992: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            loop: false,
        },
    },
});